// extracted by mini-css-extract-plugin
export default {"CriticalAnalysisMilestoneContainer":"criticalAnalysisMilestone_CriticalAnalysisMilestoneContainer__mwao1"};